import { createBaseResourceActions } from '../create-base-resource-actions';
import { MeetingTypeResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[MEETING TYPE]';
export const meetingTypeActions =
  createBaseResourceActions<MeetingTypeResourceTypeMappings>(domainSlug);
